module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAbCAYAAABWb153AAAAF0lEQVQImWPUjr77n4GBgYGJAQqGPQMAVkQCmHejyPQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/blue-line.png
// module id = 978
// module chunks = 2